const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMutation = require('app/graphql/Mutation');
const GraphQLMultiMutation = require('app/graphql/MultiMutation');

const Modal = require('app/ui/Modal');
const RangeForm = require('app/supplier/restaurant/RangeForm');

class RestaurantTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'supplier': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickAddRange = this.onClickAddRange.bind(this);
        this.onClickEnable = this.onClickEnable.bind(this);
        this.onClickDisable = this.onClickDisable.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.supplier = this.settings.supplier;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
        this.supplierForm.onDOMReady();
    }

    buildTab(){

        this.$content = $('<div/>');

        this.$btnAddRange = $('<button/>')
        .addClass('btn btn-sm btn-primary')
        .append(
            $('<i/>')
            .addClass('fas fa-plus me-1')
        )
        .append(window.translate('app.supplier.show.tabs.restaurant.actions.addRange'))
        .on('click',this.onClickAddRange);

        this.$btnDisable = $('<button/>')
        .addClass('btn btn-sm btn-danger')
        .append(
            $('<i/>')
            .addClass('fas fa-minus me-1')
        )
        .append(window.translate('app.supplier.show.tabs.restaurant.actions.disable'))
        .on('click',this.onClickDisable);

        this.$btnEnable = $('<button/>')
        .addClass('btn btn-sm btn-primary')
        .append(
            $('<i/>')
            .addClass('fas fa-check me-1')
        )
        .append(window.translate('app.supplier.show.tabs.restaurant.actions.enable'))
        .on('click',this.onClickEnable);
        

        this.$activeRestaurantActionsContainer = $('<ul/>')
        .addClass('list-inline')
        .append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnAddRange)
        )
        .append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnDisable)
        )
        .hide();

        this.$inactiveRestaurantActionsContainer = $('<ul/>')
        .addClass('list-inline')
        .append(
            $('<li/>')
            .addClass('list-inline-item')
            .append(this.$btnEnable)
        )
        .hide();

        this.$activeRestaurantListContainer = $('<div/>');
        this.$inactiveRestaurantListContainer = $('<div/>');

        this.$content.html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append(
                        $('<div/>')
                        .addClass('d-flex justify-content-center')
                        .append(
                            $('<h2/>')
                            .append(window.translate('app.supplier.show.tabs.restaurant.active.title'))
                        )
                    )
                    .append(
                        $("<div/>")
                        .addClass('d-flex justify-content-end')
                        .append(this.$activeRestaurantActionsContainer)
                    )
                    .append(this.$activeRestaurantListContainer)
                )
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append(
                        $('<div/>')
                        .addClass('d-flex justify-content-center')
                        .append(
                            $('<h2/>')
                            .append(window.translate('app.supplier.show.tabs.restaurant.inactive.title'))
                        )
                    )
                    .append(
                        $("<div/>")
                        .addClass('d-flex justify-content-end')
                        .append(this.$inactiveRestaurantActionsContainer)
                    )
                    .append(this.$inactiveRestaurantListContainer)
                )
            )
        );

        this.$container
        .html('')
        .append(this.$content);

        this.loadData();
    }


    loadData(){
        var self = this;

        this.$activeRestaurantListContainer
        .html('')
        .append(window.App.generateLoader())

        this.$inactiveRestaurantListContainer
        .html('')
        .append(window.App.generateLoader())

        let queries = [
            this.buildRestaurantSupplierAssociationQuery(),
            this.buildRestaurantQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildResult(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    refresh(){
        this.loadData();
    }

    buildRestaurantQuery(){
        var self = this;

        let parameters = {
            'filter':{
                'notSupplier': this.supplier.id,
                'particulier': false
            },
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurants',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }
    buildRestaurantSupplierAssociationQuery(){
        var self = this;

        let parameters = {
            'filter':{
                'supplier': this.supplier.id,
                'particulier': false
            },
            'orderBy': 'restaurant',
            'dir': 'ASC',
        };

        let fields = [
            'restaurant { id name }',
            'customerCodes { code }',
            'nbOrders',
            'totalOrders'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantSupplierAssociations',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildResult(data){

        this.restaurants = data.restaurants.edges;
        this.restaurantSupplierAssociations = data.restaurantSupplierAssociations.edges;

        this.buildActiveRestaurantList();
        this.buildInactiveRestaurantList();
    }

    buildActiveRestaurantList(){
        var self = this;
        let $footerContent = $('<div/>');

        let $checkboxAll = $('<input/>')
        .attr('type','checkbox')
        .addClass('active-item-check-all')
        .on('change',function(event){
            self.toggleAllActive();
        });

        let $idColHeader = $('<div/>')
        .append($checkboxAll);

        let table = new ListTable({
            '$container': this.$activeRestaurantListContainer,
            'tableClass': 'table table-striped',
            'id': 'active-restaurant-list',
            'length': 0,
            'data': this.restaurantSupplierAssociations,
            'footerContent': $footerContent,
            'columns': [
                {
                    'name': 'id',
                    'label': $idColHeader,
                    'class': 'restaurant-id',
                    'render': function(item,index){
                        let $checkbox = $('<input/>')
                        .attr('type','checkbox')
                        .data('item',item.node.restaurant)
                        .addClass('active-check')
                        .on('change',function(event){
                            self.onChangeActive();
                        });
                        return $checkbox;
                    },
                },
                {
                    'name': 'name',
                    'label': window.translate('app.supplier.show.tabs.restaurant.restaurant.name.label'),
                    'class': 'restaurant-name',
                    'render': function(item,index){
                        return item.node.restaurant.name;
                    },
                },
                {
                    'name': 'code',
                    'label': window.translate('app.supplier.show.tabs.restaurant.restaurant.code.label'),
                    'class': 'restaurant-code',
                    'render': function(item,index){
                        let customerCodes = item.node.customerCodes;
                        let codes = [];
                        for(var i in customerCodes){
                            let customerCode = customerCodes[i];
                            codes.push(customerCode.code)
                        }
                        return codes.join(', ');
                    },
                },
                {
                    'name': 'nbOrders',
                    'label': window.translate('app.supplier.show.tabs.restaurant.restaurant.nbOrders.label'),
                    'class': 'nbOrders',
                    'render': function(item,index){
                        return window.formatFloat(item.node.nbOrders);
                    },
                },
                {
                    'name': 'totalOrders',
                    'label': window.translate('app.supplier.show.tabs.restaurant.restaurant.totalOrders.label'),
                    'class': 'totalOrders',
                    'render': function(item,index){
                        return window.formatFloat(item.node.totalOrders) + ' &euro;';
                    },
                }
            ]
        });
    }


    buildInactiveRestaurantList(){
        var self = this;
        let $checkboxAll = $('<input/>')
        .attr('type','checkbox')
        .addClass('inactive-item-check-all')
        .on('change',function(event){
            self.toggleAllInactive();
        })

        let $idColHeader = $('<div/>')
        .append($checkboxAll);
        
        let $footerContent = $('<div/>');
        let table = new ListTable({
            '$container': this.$inactiveRestaurantListContainer,
            'tableClass': 'table table-striped',
            'id': 'inactive-restaurant-list',
            'length': 0,
            'data': this.restaurants,
            'footerContent': $footerContent,
            'columns': [
                {
                    'name': 'id',
                    'label': $idColHeader,
                    'class': 'restaurant-id',
                    'render': function(item,index){
                        let $checkbox = $('<input/>')
                        .attr('type','checkbox')
                        .data('item',item.node)
                        .addClass('inactive-check')
                        .on('change',function(event){
                            self.onChangeInactive();
                        });
                        return $checkbox;
                    },
                },
                {
                    'name': 'name',
                    'label': window.translate('app.supplier.show.tabs.restaurant.restaurant.name.label'),
                    'class': 'restaurant-name',
                    'render': function(item,index){
                        return item.node.name;
                    },
                }
            ]
        });
    }

    toggleAllActive(){
        let $checkboxAll = $('.active-item-check-all');
        if($checkboxAll.is(':checked')){
            $('.active-check').prop('checked',true)
        }else{
            $('.active-check').prop('checked',false)
        }

        this.onChangeActive();
    }

    onChangeActive(){
        let $checked = $('.active-check:checked');
        if($checked.length > 0){
            this.$activeRestaurantActionsContainer.show();
        }else{
            this.$activeRestaurantActionsContainer.hide();
        }
    }

    toggleAllInactive(){

        let $checkboxAll = $('.inactive-item-check-all');
        if($checkboxAll.is(':checked')){
            $('.inactive-check').prop('checked',true)
        }else{
            $('.inactive-check').prop('checked',false)
        }

        this.onChangeInactive();
    }

    getCheckedActiveRestaurants(onlyIds){
        let $checked = $('.active-check:checked');
        let restaurants = [];
        $checked.each(function(){
            let $checkbox = $(this);
            let item = $checkbox.data('item');
            if(onlyIds){
                restaurants.push(item.id);
            }else{
                restaurants.push(item);
            }
        });
        return restaurants;
    }

    getCheckedInactiveRestaurants(onlyIds){
        let $checked = $('.inactive-check:checked');
        let restaurants = [];
        $checked.each(function(){
            let $checkbox = $(this);
            let item = $checkbox.data('item');
            if(onlyIds){
                restaurants.push(item.id);
            }else{
                restaurants.push(item);
            }
        })
        return restaurants;
    }

    onChangeInactive(){
        let $checked = $('.inactive-check:checked');
        if($checked.length > 0){
            this.$inactiveRestaurantActionsContainer.show();
        }else{
            this.$inactiveRestaurantActionsContainer.hide();
        }
    }

    onClickAddRange(event){
        event.preventDefault();
        event.stopPropagation();

        let restaurants = this.getCheckedActiveRestaurants(true);
        this.showRangeForm(restaurants,true);
    }
    onClickEnable(event){
        event.preventDefault();
        event.stopPropagation();

        let restaurants = this.getCheckedInactiveRestaurants(true);
        this.showRangeForm(restaurants,false);
    }
    onClickDisable(event){
        event.preventDefault();
        event.stopPropagation();

        this.showConfirmDisableSupplier();
    }


    showConfirmDisableSupplier(){
        var self = this;

        let $content = $('<div/>')
        .addClass('p-2')
        .append(
            $('<h3/>')
            .addClass('p-2')
            .append(window.translate('app.supplier.show.tabs.restaurant.disable.title'))
        )
        .append(
            $('<div/>')
            .addClass('text-danger')
            .append(window.translate('app.supplier.show.tabs.restaurant.disable.warning'))
        )
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(window.translate('app.supplier.show.tabs.restaurant.disable.confirm'))
        )

        let confirmModal = new ConfirmModal({
            'id': "restaurantSupplierDisableConfirmModal",
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-primary btn-cancel',
            'btnConfirmContent': window.translate('yes'),
            'btnCancelContent': window.translate('no'),
            'onConfirm': function(event,modal){
                self.proceedDisableSupplier(confirmModal);
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedDisableSupplier(confirmModal){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let mutations = [];
        let restaurants = this.getCheckedActiveRestaurants();

        for(var i in restaurants){
            let restaurant = restaurants[i];

            let fields = [
                'success',
                'message',
                'errors { key, value }',
            ];
            let variables = {
                'restaurant': {
                    'value': restaurant.id,
                    'type': 'Int!'
                },
                'supplier': {
                    'value': this.supplier.id,
                    'type': 'Int!'
                },
            };
            let mutation = new GraphQLMutation({
                //Mutation parameters
                'mutationType': "DeleteRestaurantSupplierAssociation",
                'fields': fields,
                'variables': variables,

            });

            mutations.push(mutation);
        }


        let multiMutation = new GraphQLMultiMutation({
            'mutationName': 'DeleteRestaurantSupplierAssociations',

            //parameters
            'mutations': mutations,

            //callbacks
            'before': function(){
            },
            'success': function(response){
                let data = response.DeleteRestaurantSupplierAssociation;
                if(data.success){
                    window.notify(data.message,'success');
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                confirmModal.hide();
                self.refresh();
            }
        });

        multiMutation.execute();
    }

    showRangeForm(restaurants,edition){
        var self = this;
        let $content = $('<div/>')
        .addClass('supplier-restaurant-range-modal')
        .append(
            $('<div/>')
            .addClass('d-flex justify-content center')
            .addClass('text-muted')
            .append(window.translate('app.supplier.show.tabs.restaurant.addRange.message'))
        );

        if(edition){
            $content
            .append(
                $('<div/>')
                .addClass('d-flex justify-content center')
                .addClass('fw-bold')
                .append(window.translate('app.supplier.show.tabs.restaurant.addRange.warning'))
            )
        }

        let modal = new Modal({
            'id': window.uniqid(),
            'title': window.translate('app.supplier.show.tabs.restaurant.addRange.title'),
            'showFooter': false,
            'content' : $content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,

        });

        let form = new RangeForm({
            'supplier': this.supplier,
            'restaurants': restaurants,
            'success': function(data){
                window.notify(data.message,"success");
                self.refresh();
                modal.hide();
            }
        })

        $content.append(form.getForm());

        modal.show();
    }

}

module.exports = RestaurantTab;

